import { FormLabelClassKey, StyleRules } from '@material-ui/core';

const MuiFormLabel: Partial<StyleRules<FormLabelClassKey, {}>> = {
  root: {
    fontWeight: 400,
    fontSize: '1rem',
    '&.Mui-disabled': {
      color: 'rgb(145, 158, 171)',
    },
    // Guinda para el feedback de validacion (--ds-color-error-700). El rojo vivo
    // queda para alarmas y acciones destructivas.
    '&.Mui-error': {
      color: 'var(--ds-color-error-700)',
    },
  },
};

export default MuiFormLabel;
